import {Component, OnInit} from '@angular/core';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectService
} from '../../_services/index';

import {ActivatedRoute, Router} from '@angular/router';

import {Project, User} from '../../_models/index';
import {LoginHelper} from '../../helpers';
import {IndexConfigService} from "../../_services/index.config.service";
import {saveAs as importedSaveAs} from "file-saver";
import * as moment from 'moment';

@Component({
    standalone: false,
  selector: "cidreport-component",
  templateUrl: 'cidreport.component.html',
  styleUrls: ['./cidreport.component.scss'],
})

export class CidReportComponent implements OnInit {
  items: any[] = [];
  currentUser: User;
  projectId: number;
  project: Project;
  rowGroupMetadata: any = {};
  tenantName: string;
  date = new Date();
  implementationStatuses: any =
    {
      0: "None",
      1: "Implemented",
      2: "Partially Implemented",
      3: "Planned",
      4: "Alternative Implementation",
      5: "Not Applicable",
      7: "Not Implemented"
      //6: "Ongoing",
    };

  actionItemStatuses: any =
    {
      0: "Not Started",
      1: "In-Progress",
      2: "Resolved",
      3: "Awaiting Review",
      4: "Reviewed - Not POAM"
    };

  cols : any[] = [
    {'field': 'complianceAreaControlId', 'header': 'Control ID', width: '10em'},
    {'field': 'description', 'header': 'Description'},
    {'field': 'implementationStatus', 'header': 'Implementation Status', width: '14em'},
    {'field': 'icsLastUpdated', 'header': 'ICS Last Updated', width: '14em'},
    {'field': 'evidencesText', 'header': 'Most Recent Evidence'},
    {'field': 'policiesText', 'header': 'Attached Policies/Procedures'},
    {'field': 'openPoamsText', 'header': 'Open POAMs'},
    {'field': 'completionsText', 'header': 'Completions'},
    {'field': 'dependencyListText', 'header': 'Dependencies'}
  ]
  columnVisibility = {};
  columnOptions = [];

  constructor(
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public config: IndexConfigService,
    public clientProfileService: ClientProfileService,
    public fileBlobService: FileBlobService,
    public authenticationService: AuthenticationService) {

    this.projectId = route.snapshot.params['projectId'];
  }

  ngOnInit() {

    const tenantName = this.tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.loadData();
  }

  public loadData() {

    this.projectService.getById(this.projectId)
      .subscribe(project => {
          this.project = project;
        },

        error => {
          const errorMessage = 'An error occurred while loading projects.';
          this.alertService.error(errorMessage);
        });
    this.projectService.getCidReport(this.projectId)
      .subscribe(data => {
          this.items = data;
          data.forEach(i => {
            i.evidencesText = (i.evidences || []).map(e => (e.date ? moment(e.date).format('MM/DD/YYYY') : '') + ' - ' + e.name).join('\r\n');
            i.policiesText = (i.policies || []).join('\r\n');
            i.openPoamsText = (i.openPoams || []).map(o => this.actionItemStatuses[o.currentStatus] + ' ' + o.riskLevel + ' ' + o.weaknessDescription + ' - ' + (o.scheduledCompletionDate ? moment(o.scheduledCompletionDate).format('MM/DD/YYYY') : '')).join('\r\n');
            i.completionsText = (i.completions || []).map(c => (c.isCompleted ? 'Completed' : 'Not Completed') + ' -  ' + (c.modified ? 'Updated:' + moment(c.modified).format('MM/DD/YYYY') : '')).join('\r\n');
            i.dependencyListText = (i.dependencyList || []).map(d => d.projectName + ' - ' + d.controlItem.category + '/' + d.controlItem.complianceAreaControlId).join('\r\n');
          });
        },

        error => {
          const errorMessage = 'An error occurred while loading project data.';
          this.alertService.error(errorMessage);
        });

    this.clientProfileService.getUserSetting('CidReportTable').subscribe(c => {
      this.columnVisibility = (c || {}).columnVisibility || {};
      this.columnOptions = [];
      for (let i = 0; i < this.cols.length; i++) {
        this.columnOptions.push({label: this.cols[i].header, value: this.cols[i]});
      }
      this.cols = this.cols.filter(col => this.columnVisibility[col.field] !== false);
    })

  }

  public DownloadEvidence(projectControlItem, fileName: string) {

    this.fileBlobService
      .downloadFile(fileName, "Projects/" + this.project.name + '/Evidence/' + projectControlItem.shortFolderName)
      .subscribe(res => {
          importedSaveAs(new Blob([res]), fileName);
        },
        error => {
          const errorMessage = error.status == 401 ? 'The logged in user does not have access to the file\'s location. ' : 'The referenced file no longer exists in the document library.';
          this.alertService.error(errorMessage);
        });
  }

  onPanelHide() {
    /*var row = (<any>this.table).tableViewChild.nativeElement.children[0].children[0];
    var width = row.clientWidth;
    var sizes = [];
    for (var i = 0; i < row.children.length - 2; i++) {
      sizes.push(row.children[i].clientWidth / width * 100 + '%');
    }*/
    this.columnVisibility = {};
    this.cols.sort((a, b) => this.columnOptions.indexOf(this.columnOptions.find(c => c.value == a)) - this.columnOptions.indexOf((this.columnOptions.find((c => c.value == b)))));
    for (let i = 0; i < this.columnOptions.length; i++) {
      if (!this.cols.find(c => c.field == this.columnOptions[i].value.field)) {
        this.columnVisibility[this.columnOptions[i].value.field] = false;
      }
    }
    this.clientProfileService.saveUserSetting("CidReportTable", {columnVisibility: this.columnVisibility}).subscribe(() => {
    });
  }

}
